import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { IUserMp3 } from "@/types/user.types";
import selectColorMp3 from "@/components/common/selectColorMp3";
import { SITE_DOMAIN } from "@/constant";
import { Mp3Preview } from "@/types/stateTypes";

export const useUserMp3 = create<IUserMp3>((set) => ({
  data: {
    dynamic: "1",
    mp3: "",
    mp3_path: "",
    mp3_name: "",
    mp3_size: 0,
    title: "",
    info: "",
    name: "",
    logo: "",
    logo_name: "",
    logo_type: "",
    logo_path: "",
    welcome_screen: "",
    welcome_path: "",
    website: "",
    design_colors_primary: selectColorMp3[0].color,
    design_colors_button: selectColorMp3[0].buttonColor,
    button: "",
    button_url: "",
    showButton: false,
  },
  config: {},
  addButton: [
    {
      value: "Buy now",
      icon: "",
    },
    {
      value: "Learn more",
      icon: "",
    },
    {
      value: "Visit us online",
      icon: "",
    },
    {
      value: "View full album",
      icon: "",
    },
    {
      value: "Custom",
      icon: "/common/edit-icon.svg",
    },
  ],
  fromApi: "storage",
  mp3Preview: "",
  destroyUserMp3: () => {
    set({
      data: {
        dynamic: "1",
        mp3: "",
        mp3_path: "",
        mp3_name: "",
        mp3_size: 0,
        title: "",
        info: "",
        name: "",
        logo: "",
        logo_name: "",
        logo_type: "",
        logo_path: "",
        welcome_screen: "",
        welcome_path: "",
        website: "",
        design_colors_primary: selectColorMp3[0].color,
        design_colors_button: selectColorMp3[0].buttonColor,
        button: "",
        button_url: "",
        showButton: false,
      },
      config: {},
      addButton: [
        {
          value: "Buy now",
          icon: "",
        },
        {
          value: "Learn more",
          icon: "",
        },
        {
          value: "Visit us online",
          icon: "",
        },
        {
          value: "View full album",
          icon: "",
        },
        {
          value: "Custom",
          icon: "/common/edit-icon.svg",
        },
      ],
      fromApi: "storage",
      mp3Preview: "",
    });
  },
  setUserMp3: (val) => {
    set((state) => {
      return { ...state, data: { ...state.data, ...val } };
    });
  },
  setConfig: (val) =>
    set((state) => ({
      ...state,
      config: { ...state.config, val },
    })),
  setFromApi: (val) => {
    set((state) => {
      return { ...state, fromApi: val };
    });
  },
}));

export const useMp3Preview = create<Mp3Preview>((set) => ({
  mp3Preview: {
    file: "",
    name: "",
    size: null,
    showDropzone: false,
    loaded: 0,
    finish: "no",
  },
  setMp3Preview: (val) => {
    set((state) => {
      return { ...state, mp3Preview: { ...state.mp3Preview, ...val } };
    });
  },
  destroyMp3Preview: () => {
    set({
      mp3Preview: {
        file: "",
        name: "",
        size: null,
        showDropzone: false,
        loaded: 0,
        finish: "no",
      },
    });
  },
}));
